import EyeClose from "../../assets/icons/Eye/EyeClose";
import EyeOpen from "../../assets/icons/Eye/EyeOpen";
import { login } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
// import { submitConnection } from "./Login.function";
import "./Login.scss";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// import { useNavigate } from "react-router-dom";

const Login = () => {
  const username = useRef() as React.MutableRefObject<HTMLInputElement>;
  const password = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [isFilled, setIsFilled] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { error } = useSelector((state: RootState) => state.auth);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      login({
        username: username.current.value,
        password: password.current.value,
      })
    );
  };

  const _enableButton = () =>
    setIsFilled(
      !!username.current.value.length && !!password.current.value.length
    );
  const [showPassword, setShowPassword] = useState(false);

  return (
    <section id="login">
      <div id="login-modale">
        <h3>J’AI DÉJÀ UN COMPTE</h3>
        <form onSubmit={handleSubmit}>
          <input
            onChange={() => _enableButton()}
            type="text"
            id="username"
            name="sp-username"
            ref={username}
            autoCapitalize="off"
            autoCorrect="off"
            autoFocus
            required
            placeholder="Identifiant ou e-mail*"
          />
          <div className="input-password">
            <input
              onChange={() => _enableButton()}
              type={showPassword ? "text" : "password"}
              id="password"
              name="sp-password"
              ref={password}
              required
              placeholder="Mot de passe*"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              id="toggle-button"
            >
              {showPassword ? <EyeOpen /> : <EyeClose />}
            </button>
          </div>
          <button disabled={!isFilled} type="submit" className="button">
            Se connecter
          </button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>
    </section>
  );
};

export default Login;
